import { Grid } from '@mui/material'
import { useFormikContext, useField } from 'formik'
import { t } from 'i18next'
import { SwitchField } from 'src/components/shared/ui/form/fields'
import { EscritosFormValues } from 'src/components/views/EscritosLexnet/components/shared/types/escritosFormTypes'
import { Orden as OrdenMaster } from 'src/enums/EscritosLegales'
import { FormField } from 'src/enums/Form'
import { Orden } from 'src/interfaces/Catalog'

function DatosSwitches(): JSX.Element {
  const { setFieldValue } = useFormikContext<EscritosFormValues>()
  const [orden] = useField<Orden>(
    `${FormField.ORGANO_DESTINO}.${FormField.ORGANO_DESTINO_ORDEN_JUDICIAL}`
  )

  function checkMedidaSwitch(_value, event) {
    const { id } = event.target

    switch (id) {
      case FormField.DATOS_MEDIDA_CAUTELAR_PREVIA:
        setFieldValue(FormField.DATOS_CAUTELARISIMA, false, false)
        setFieldValue(FormField.DATOS_MEDIDA_CAUTELAR_COETANEA, false, false)
        break
      case FormField.DATOS_CAUTELARISIMA:
        setFieldValue(FormField.DATOS_MEDIDA_CAUTELAR_PREVIA, false, false)
        setFieldValue(FormField.DATOS_MEDIDA_CAUTELAR_COETANEA, false, false)
        break
      case FormField.DATOS_MEDIDA_CAUTELAR_COETANEA:
        setFieldValue(FormField.DATOS_MEDIDA_CAUTELAR_PREVIA, false, false)
        setFieldValue(FormField.DATOS_CAUTELARISIMA, false, false)
        break
      default:
        break
    }
  }

  function showCautelarisimaSwitch(): JSX.Element | null {
    if (orden.value && orden.value.orden === OrdenMaster.CONTENCIOSO) {
      return (
        <Grid item xs={6} sm={3}>
          <SwitchField
            id={FormField.DATOS_CAUTELARISIMA}
            label={t('form.field.datos_cautelarisima')}
            onChange={checkMedidaSwitch}
          />
        </Grid>
      )
    }
    return null
  }

  function showCausaSwitches(): JSX.Element | null {
    if (orden.value && orden.value.orden === OrdenMaster.PENAL) {
      return (
        <>
          <Grid item xs={6} sm={3}>
            <SwitchField
              id={FormField.DATOS_CAUSA_CON_DETENIDO}
              label={t('form.field.datos_causa_con_detenido')}
            />
          </Grid>
          <Grid item xs={6} sm={3}>
            <SwitchField
              id={FormField.DATOS_CAUSA_CON_PRESO}
              label={t('form.field.datos_causa_con_preso')}
            />
          </Grid>
        </>
      )
    }
    return null
  }

  function showViolenciaGeneroSwitch(): JSX.Element | null {
    const options = [OrdenMaster.CIVIL, OrdenMaster.PENAL]
    if (orden.value && options.includes(orden.value.orden)) {
      return (
        <Grid item xs={6} sm={3}>
          <SwitchField
            id={FormField.DATOS_VIOLENCIA_GENERO}
            label={t('form.field.datos_violencia_genero')}
          />
        </Grid>
      )
    }
    return null
  }

  function showMedidaCautelarPreviaSwitch(): JSX.Element | null {
    if (orden.value && orden.value.orden !== OrdenMaster.ESPECIAL) {
      return (
        <Grid item xs={6} sm={3}>
          <SwitchField
            id={FormField.DATOS_MEDIDA_CAUTELAR_PREVIA}
            label={t('form.field.datos_medida_cautelar_previa')}
            onChange={checkMedidaSwitch}
            disabled={!orden.value}
          />
        </Grid>
      )
    }
    return null
  }

  function showMedidaCautelarCoetaneaSwitch(): JSX.Element | null {
    if (orden.value && orden.value.orden !== OrdenMaster.ESPECIAL) {
      return (
        <Grid item xs={6} sm={3}>
          <SwitchField
            id={FormField.DATOS_MEDIDA_CAUTELAR_COETANEA}
            label={t('form.field.datos_medida_cautelar_coetanea')}
            onChange={checkMedidaSwitch}
            disabled={!orden.value}
          />
        </Grid>
      )
    }
    return null
  }

  return (
    <Grid container spacing={2}>
      {showMedidaCautelarPreviaSwitch()}
      {showCautelarisimaSwitch()}
      {showMedidaCautelarCoetaneaSwitch()}
      {showCausaSwitches()}
      {showViolenciaGeneroSwitch()}
      <Grid item xs={6} sm={3}>
        <SwitchField
          id={FormField.DATOS_URGENTE}
          label={t('form.field.urgente')}
          disabled={!orden.value}
        />
      </Grid>
    </Grid>
  )
}

export default DatosSwitches
